import { Chart } from 'chart.js';
import Labels from './labels';
import { createValueLabelsPlugin } from './valueLabelsPlugin';

const getNumberTasksByPeriod = (ctxId, state, tasks) => {
    const ctx = document.getElementById(ctxId);

    if (!ctx) {
        return
    }

    if (state.chartNumberTask) {
        state.chartNumberTask.destroy();
    }

    const labels = {
        daily: Labels(state.shiftPeriod).daily,
        monthly: Labels(state.shiftPeriod).monthly,
        quarterly: Labels(state.shiftPeriod).quarterly,
        yearly: Labels(state.shiftPeriod).yearly
    }

    const data = getData(tasks, state)
    
    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels[state.period],
            datasets: [{
                label: 'No reparadas',
                data: data[state.period].incomplete,
                backgroundColor: '#fa4c4c',
                borderColor: '#fa4c4c',
                borderWidth: 1
            },
            {
                label: 'Reparadas',
                data: data[state.period].complete,
                backgroundColor: '#4cc488',
                borderColor: '#4cc488',
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                xAxes: [{
                    stacked: true,
                    gridLines: {
                        color: 'rgba(200, 200, 200, 0.2)'
                    },
                    ticks: {
                        fontColor: 'black'
                    }
                }],
                yAxes: [{
                    stacked: true,
                    gridLines: {
                        color: 'rgba(200, 200, 200, 0.2)'
                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: 'black'
                    }
                }]
            },
            legend: {
                labels: {
                    fontColor: 'black'
                }
            },
            tooltips: {
                enabled: false
            },
        },
        plugins: [createValueLabelsPlugin({
            format: (v) => `${Number(v)}`
        })]
    });

    return chart;
}

const getData = (tasks, state) => {
    // Inicializar estructuras para cada período
    const dailyData = {};
    const monthlyData = {};
    const quarterlyData = {};
    const yearlyData = {};

    Labels(state.shiftPeriod).dailyIds.forEach(id => {
        dailyData[id] = { complete: 0, incomplete: 0 };
    });

    Labels(state.shiftPeriod).monthlyIds.forEach(id => {
        monthlyData[id] = { complete: 0, incomplete: 0 };
    });

    Labels(state.shiftPeriod).quarterlyIds.forEach(id => {
        quarterlyData[id] = { complete: 0, incomplete: 0 };
    });

    Labels(state.shiftPeriod).yearlyIds.forEach(id => {
        yearlyData[id] = { complete: 0, incomplete: 0 };
    });

    // Procesar cada tarea
    tasks.forEach(task => {
        const isRepaired = Number(task.state) === 2;
        
        // Para tareas NO reparadas: usar dateEntry
        // Para tareas reparadas: usar dateRepaired
        let relevantDate;
        
        if (isRepaired && task.dateRepaired) {
            relevantDate = new Date(task.dateRepaired);
        } else {
            relevantDate = new Date(task.dateEntry);
        }

        const day = relevantDate.getDate();
        const month = relevantDate.getMonth() + 1;
        const year = relevantDate.getFullYear();

        // Claves para cada período
        const dailyKey = `${day}-${month}-${year}`;
        const monthlyKey = `${month}-${year}`;
        const quarterlyKey = `Q${Math.floor((month - 1) / 3) + 1}-${year}`;
        const yearlyKey = `${year}`;

        // Actualizar datos diarios
        if (dailyData[dailyKey] !== undefined) {
            if (isRepaired) {
                dailyData[dailyKey].complete += 1;
            } else {
                dailyData[dailyKey].incomplete += 1;
            }
        }

        // Actualizar datos mensuales
        if (monthlyData[monthlyKey] !== undefined) {
            if (isRepaired) {
                monthlyData[monthlyKey].complete += 1;
            } else {
                monthlyData[monthlyKey].incomplete += 1;
            }
        }

        // Actualizar datos trimestrales
        if (quarterlyData[quarterlyKey] !== undefined) {
            if (isRepaired) {
                quarterlyData[quarterlyKey].complete += 1;
            } else {
                quarterlyData[quarterlyKey].incomplete += 1;
            }
        }

        // Actualizar datos anuales
        if (yearlyData[yearlyKey] !== undefined) {
            if (isRepaired) {
                yearlyData[yearlyKey].complete += 1;
            } else {
                yearlyData[yearlyKey].incomplete += 1;
            }
        }
    });

    // Convertir a arrays en el orden correcto
    const dailyValues = Labels(state.shiftPeriod).dailyIds.map(id => dailyData[id]);
    const monthlyValues = Labels(state.shiftPeriod).monthlyIds.map(id => monthlyData[id]);
    const quarterlyValues = Labels(state.shiftPeriod).quarterlyIds.map(id => quarterlyData[id]);
    const yearlyValues = Labels(state.shiftPeriod).yearlyIds.map(id => yearlyData[id]);

    return {
        daily: {
            complete: dailyValues.map(v => v.complete),
            incomplete: dailyValues.map(v => v.incomplete)
        },
        monthly: {
            complete: monthlyValues.map(v => v.complete),
            incomplete: monthlyValues.map(v => v.incomplete)
        },
        quarterly: {
            complete: quarterlyValues.map(v => v.complete),
            incomplete: quarterlyValues.map(v => v.incomplete)
        },
        yearly: {
            complete: yearlyValues.map(v => v.complete),
            incomplete: yearlyValues.map(v => v.incomplete)
        }
    };
}

export default getNumberTasksByPeriod